import * as Sentry from "@sentry/browser";

const sentryConfig = window.__SENTRY_CONFIG__ || null;
if (sentryConfig && sentryConfig.dsn) {
    Sentry.init({
        ...sentryConfig,
        integrations: [
            Sentry.browserTracingIntegration(),
        ],
    });
    window.Sentry = Sentry;
}

export default Sentry;
